module.exports = __webpack_public_path__ + "img/Spin-1s-20px.33e51c2f.gif";